import {
  ScheduledAssessment,
  TraitAssessmentResult,
} from "@dimensional-engineering/dimensional-models";
import { PayloadAction, createSlice } from "@reduxjs/toolkit";

type ScheduleAssessmentSlice = {
  scheduledAssessments: ScheduledAssessment[];
  traitAssessmentResults: TraitAssessmentResult[];
  traitAssessmentInProgressScheduleIdentifiers: string[];
};

const initialState: ScheduleAssessmentSlice = {
  scheduledAssessments: [],
  traitAssessmentResults: [],
  traitAssessmentInProgressScheduleIdentifiers: [],
};

export const scheduledAssessments = createSlice({
  name: "scheduledAssessments",
  initialState: initialState,
  reducers: {
    setScheduledAssessments: (
      state,
      action: PayloadAction<ScheduledAssessment[]>
    ) => {
      return { ...state, scheduledAssessments: action.payload };
    },
    setTraitAssessmentResults: (
      state,
      action: PayloadAction<TraitAssessmentResult[]>
    ) => {
      return { ...state, traitAssessmentResults: action.payload };
    },
    setScheduleIdentitfiers: (state, action: PayloadAction<string[]>) => {
      return {
        ...state,
        traitAssessmentInProgressScheduleIdentifiers: action.payload,
      };
    },
  },
});

export const {
  setScheduledAssessments,
  setTraitAssessmentResults,
  setScheduleIdentitfiers,
} = scheduledAssessments.actions;

export default scheduledAssessments.reducer;
